// extracted by mini-css-extract-plugin
export var closeButton = "_2n-0";